import { formatPercent } from '@/lib/utils'
import type { ClosedDaysReportLocation } from '@/lib/services/reports/reports.types'

export interface ClosedDaysChartRow extends ClosedDaysReportLocation {
  selected_day_count: number
  pickup_only_days: number
  delivery_only_days: number
  both_days: number
  no_explicit_pause_days: number
}

export function buildClosedDaysChartRows(
  locations: ClosedDaysReportLocation[] = [],
  selectedDayCount = 0
): ClosedDaysChartRow[] {
  return locations.map((location) => {
    const pickupDays = location.pickup_closed_days ?? 0
    const deliveryDays = location.delivery_closed_days ?? 0
    const bothDays = location.overlap_closed_days ?? 0
    const pickupOnlyDays = Math.max(0, pickupDays - bothDays)
    const deliveryOnlyDays = Math.max(0, deliveryDays - bothDays)
    const eitherServiceDays = pickupOnlyDays + deliveryOnlyDays + bothDays

    return {
      ...location,
      selected_day_count: selectedDayCount,
      pickup_only_days: pickupOnlyDays,
      delivery_only_days: deliveryOnlyDays,
      both_days: bothDays,
      no_explicit_pause_days: Math.max(0, selectedDayCount - eitherServiceDays),
    }
  })
}

export function formatClosedDaysPercent(days: number, selectedDayCount: number): string {
  if (!selectedDayCount) {
    return formatPercent(0, 0)
  }

  const ratio = days / selectedDayCount
  const percentage = ratio * 100
  const digits = Math.abs(percentage - Math.round(percentage)) < 0.000001 ? 0 : 1

  return formatPercent(ratio, digits)
}
